import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {DISCOUNT_TYPES, discountInterFace, discountSectionsInterface} from "./discounstInterface";
import DiscountCommon from "./discountCommon";
import {setDiscountSections} from "../../actions/priceWorksheetActions";
// import {FormattedMessage} from "react-intl";

class DiscountAdd extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterFace),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  addCustomDiscountClick = () => {
    const currentDiscount = this.props.discount;
    currentDiscount.specialVisible = !currentDiscount.specialVisible;
    this.updateDiscount(currentDiscount);
  };

  setAmountValue = (event) => {
    const value = +event.target.value;
    const {discount} = this.props;
    if (discount.type === DISCOUNT_TYPES.percent && (value < 0 || value > 100)) {
      return false
    }
    const grandTotal = this.getGrandTotal(discount);
    if ((grandTotal > value) && value > 0) {
      this.setDiscountProperty("amount", +event.target.value)
    }
  };

  render() {
    const {discount, fabricatorData} = this.props;
    const disabled = this.isDiscountDisabled();
    return (
      <li className={"discount discount-custom" + (discount.specialVisible ? " discount-custom--visible" : "")
      + (disabled ? " discount--disabled" : "")}>
        <div className="add-section" onClick={this.addCustomDiscountClick}>
          <div className="add-section-header">
            <span className="add-section-header__plus">+</span>
            <div className="add-section-header__title">
              {/*<FormattedMessage id="shoppingCart.discounts.addCustomDiscount"/>*/}
            </div>
          </div>
          <div className="add-section-body">
            <span className="add-section-body__sidebar"/>
            <span className="add-section-body__content"/>
          </div>
        </div>
        <div className="discount discount--special discount--special--hidden">
          <div className="discount-cell discount-cell--select">
            <button className={"ui-checkbox" + (discount.selected ? " ui-checkbox--checked" : "")}
                    onClick={this.handleDiscountSelectClick}/>
          </div>
          <div className="discount-cell discount-cell--special-name">
            <input className="ui-input discount-special__name"
                   value={discount.name}
                   onChange={(event) => this.setDiscountProperty("name", event.target.value)}/>
          </div>
          <div className="discount-cell discount-cell--special-amount">
            {fabricatorData.isCaesarStone ? (
              <span className="discount-special__type">
                {discount.type === DISCOUNT_TYPES.percent ? " %" : fabricatorData.settings.currencySign}
              </span>
            ) : null}
            <input className="ui-input discount-special__amount"
                   type={"number"}
                   value={discount.amount}
                   onChange={this.setAmountValue}/>
          </div>
          <div className="discount-cell discount-cell--delete">
            <button className="ui-close discount-special__delete" onClick={this.addCustomDiscountClick}/>
          </div>
        </div>
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    discountSections: store.priceWorksheetState.discountSections,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorData: store.fabricatorState,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
  };
};

const mapDispatchToProps = {
  setDiscountSections
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountAdd);
